let programCards = document.querySelectorAll('.program-card');

programCards.forEach((el) => {
    let detailBtn = el.querySelector('button.btn-success');

    detailBtn.addEventListener('click', () => {
        let cardIcon = el.querySelector('.program-card__icon');
        let cardList = el.querySelector('.program-card__list');
        let cardLink = el.querySelector('a.btn-default');

        el.style.display = 'flex';
        cardIcon.style.display = 'none';
        cardList.style.maxHeight = "100%";
        el.style.maxHeight = '100%';
        el.style.transition = 'all .5s ease-in-out';
        detailBtn.style.display = "none";
        cardLink.style.display = "block";
        el.querySelector('.program-card__title').style.marginBottom = '20px';
    });
})

document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('program-card') &&
        !e.target.parentNode.classList.contains('program-card')) {
        programCards.forEach((el) => {
            let detailBtn = el.querySelector('button.btn-success');
            let cardIcon = el.querySelector('.program-card__icon');
            let cardList = el.querySelector('.program-card__list');
            let cardLink = el.querySelector('a.btn-default');

            cardIcon.style.display = 'grid';
            cardList.style.maxHeight = "0";
            el.style.maxHeight = '300px';
            el.style.transition = 'all .5s ease-in-out';
            detailBtn.style.display = "block";
            cardLink.style.display = "none";
            el.style.display = 'grid';
            el.querySelector('.program-card__title').style.marginBottom = '0px';
        })
    }
});

try{
    document.querySelector('.header__btn').addEventListener('click',()=>{
        document.querySelector('.header-nav__list').classList.toggle('show');
        document.querySelector('.header__btn').classList.toggle('opened');
    });
}catch (e) {
    
}